<template>
  <div class="ba-card ba-w-100 ba-flex ba-f-column ba-gp-1">
    <div class="ba-top">
      <div class="ba-title">{{ t.label_invoices }}</div>
      <!--      <div v-if="activeTab == 1"-->
      <!--           class='ba-box-search-input ba-sm'-->
      <!--      >-->
      <!--        <input type='search' class='ba-input' placeholder='Search...' />-->
      <!--        <button class='ba-button'>-->
      <!--          <builderall-icon code='search' />-->
      <!--        </button>-->
      <!--      </div>-->
      <button v-if="activeTab == 2"
              :class="['ba-btn ba-sm ba-blue text-capitalize', $v.$invalid ? 'ba-disabled' : '']"
              @click="!$v.$invalid ? submitNfseData() : null"
      >
        {{ t.mc_admin_send_button }}
      </button>
      <div v-if="activeTab == 3">
        <div class="ba-flex ba-flex ba-jc-fe ba-gp-06">
          <div class='ba-box-input ba-md'>
            <div class="ba-flex ba-jc-sb ba-gp-06 ">
              <select class='ba-select ba-md' v-model="period">
                <option v-for="(p, i) in periods" :key="i" v-bind:value="p">{{p}}</option>
              </select>
              <button class='ba-btn ba-sm ba-red' @click.prevent="print(true, 'ba6-modal-receipt', 'show')" :disabled="IsEmpty(payments)">
                <builderall-icon code='7535'></builderall-icon>
                {{ t.print_receipt }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <builderall-loader class="ba-w-100" :loading="loading">
      <div class='ba-box-tabs ba-mg-b-1'>
        <div @click="() => {activeTab = 1, printReceiptType = 'notification'}" :class="['ba-tab', activeTab == 1 ? 'ba-is-active' : '']">{{ t.label_invoices }}</div>
        <div @click="() => {activeTab = 2, printReceiptType = 'notification', getAddressInfoByZipcode(nfseData.cep)}" :class="['ba-tab', activeTab == 2 ? 'ba-is-active' : '']"  v-if="invoicesData.lang == 'br'">{{ t.your_invoices_data }}</div>
        <div @click="() => {activeTab = 3, printReceiptType = 'period'}" :class="['ba-tab', activeTab == 3 ? 'ba-is-active' : '']" v-if="nfseData.release_billing">{{ t.billing }}</div>
      </div>

      <!-- Invoices Tab -->
      <div v-if="activeTab == 1"
           class="ba-invoices ba-flex ba-f-column ba-gp-1"
      >
        <div v-if="!IsEmpty(invoices)"
             v-for="(invoice, i) in paginatedData" :key="invoice.id"
             :class="['invoice ba-w-100', invoice.open_accordion ? '' : 'collapsed']"
        >
          <div :class="['header-accordion ba-flex ba-ai-center ba-jc-sb', invoice.open_accordion ? 'oppened' : '']">
            <div class="left ba-flex ba-ai-center">
              <div>
                <span class="ba-montserrat-600 ba-color-dark5 ba-f-16">#{{ invoice.id }}</span>
                <span v-if="invoice.titulo==='Payment of domain'"
                      class="ba-montserrat-600 ba-color-dark5 ba-f-16"
                >
                  {{ invoice.descricao.replace('Payment of domain ', '') }}
                </span>
                <span v-if="invoice.plano"
                      class="ba-montserrat-600 ba-color-dark5 ba-f-16"
                >
                  <strong>{{ t.ad_config_ad_plan }}</strong>: {{ invoice.plano }}
                </span>
                <span v-if="!IsEmpty(invoice.note.domain_registry)"
                      class="ba-montserrat-600 ba-color-dark5 ba-f-16"
                >
                  {{ getDomainName(invoice.note.domain_registry) }}
                </span>
                <span v-else-if="invoice.fee"
                      class="ba-montserrat-600 ba-color-dark5 ba-f-16"
                >
                  {{ invoice.fee }}
                </span>
              </div>
              <span v-if="invoicesData.fatherIsBuilderall && invoice.payment_information"
                    class='ba-btn ba-sm ba-blue ba-f-12'
                    @click="paymentMethod(invoice.payment_information)"
              >
              {{ t.payment_method }}
            </span>
            </div>

            <!--    BADGES    -->
            <div class="right ba-flex ba-ai-center">
              <span v-if="invoice.fee" :style="getBadgeColor('default')" class="ba-badge ba-md badge-status">{{ t.label_fee }}</span>
              <span v-if="invoice.franchise" :style="getBadgeColor('warning')" class="ba-badge ba-lg badge-status">2 Tier</span>
              <span v-if="invoice.recorrente && !invoice.recorrente_ativo && invoice.payment_status != 'Pending'" :style="getBadgeColor('canceled')" class="ba-badge ba-lg badge-status">{{ i.payment_status }} {{ t.label_cancelado }}</span>
              <span v-if="invoice.payment_status == 'Pending'" :style="getBadgeColor('pending')" class="ba-badge ba-lg badge-status">{{ t.label_pending }}</span>
              <span v-if="invoice.recorrente" :style="getBadgeColor('recorrente')" class="ba-badge ba-lg badge-status">{{ t.label_recorrente }}</span>
              <span v-if="invoice.titulo==='Payment of extra connection'" :style="getBadgeColor('extraConnection')" class="ba-badge ba-lg badge-status">{{ t.extra_connection }}</span>
              <span v-if="invoice.titulo==='Payment of extra storage'" :style="getBadgeColor('extraStorage')" class="ba-badge ba-lg badge-status">{{ t.extra_storage }}</span>
              <span v-if="invoice.titulo==='Payment of domain' || !IsEmpty(invoice.note.domain_registry)" :style="getBadgeColor('domain')" class="ba-badge ba-lg badge-status">{{ t.domain_btn }}</span>
              <span v-if="invoice.instant_commission" :style="getBadgeColor('instantCommissions')" class="ba-badge ba-lg badge-status">{{ t.instant_commissions }}</span>
              <div @click="toggleInvoice(i)" :class="['cursor-pointer icon-transition',invoice.open_accordion ? 'rotate-180' : '']">
                <svg data-v-6e9d19a8="" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path data-v-6e9d19a8="" d="M15.3901 6.31844C15.2324 6.31845 15.0762 6.34954 14.9305 6.40994C14.7849 6.47034 14.6525 6.55886 14.5411 6.67044L10.2961 10.9144L6.05208 6.67044C5.94046 6.55882 5.80794 6.47027 5.6621 6.40986C5.51626 6.34945 5.35994 6.31836 5.20208 6.31836C4.88327 6.31836 4.57752 6.44501 4.35208 6.67044C4.24046 6.78206 4.15191 6.91458 4.0915 7.06042C4.03109 7.20627 4 7.36258 4 7.52044C4 7.83925 4.12665 8.14501 4.35208 8.37044L9.44508 13.4604C9.55657 13.5723 9.68904 13.6611 9.8349 13.7216C9.98076 13.7822 10.1371 13.8134 10.2951 13.8134C10.453 13.8134 10.6094 13.7822 10.7553 13.7216C10.9011 13.6611 11.0336 13.5723 11.1451 13.4604L16.2391 8.36744C16.4071 8.19961 16.5215 7.98571 16.5679 7.75281C16.6143 7.51991 16.5905 7.27848 16.4996 7.05909C16.4087 6.8397 16.2548 6.65222 16.0573 6.52038C15.8597 6.38853 15.6276 6.31825 15.3901 6.31844Z" fill="#8D9EB5"></path>
                </svg>
              </div>
            </div>
          </div>

          <div class="body-accordion" v-if="invoice.open_accordion">
            <div class="first-informations">
              <div class="payment-method">{{ invoice.method }}</div>
              <strong><span v-if="invoice.plano">{{ `${t.ad_config_ad_plan}: ${invoice.plano} ${t.label_recorrente}: ${invoice.recorrente ? t.yes : t.no}` }}</span><span v-if="invoice.recorrente">, {{ invoice.recorrente_ativo ? t.office2_autopilot_rede_label_ativo : t.office2_autopilot_rede_label_inativo }}</span></strong>
              <a class="ba-btn ba-sm ba-blue ba-f-12" v-if="showPaynow(invoice)" :href="invoiceUrl(invoicesData.invoiceUrl, invoice)">{{ t.pay_now }}</a>
              <button class="ba-btn ba-sm ba-red ba-f-12"
                      v-if="invoice.recorrente && invoice.recorrente_ativo"
                      @click="isSupported(invoice.method) ? openPauseModal(invoice) : ''"
              >
                <span v-if="isSupported(invoice.method)" class="ba-f-12">{{ t.button_cancelar }}</span>
                <span v-else class="ba-f-12">{{ t.cancel_unavailable }}</span>
              </button>
            </div>

            <div class="informations">
              <table class='ba-table ba-lg ba-lines ba-w-100'>
                <thead>
                <tr>
                  <th>{{ t.label_date }}</th>
                  <th>{{ t.label_price }}</th>
                  <th>{{ t.label_status }}</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(notification, y) in invoice.notificacoes" :key="y" v-if="statusToShowShow.includes(notification.status)">
                  <td class="informations-data" v-text="notification.date"/>
                  <td class="informations-price" v-text="`${notification.currency} ${notification.amount.toFixed(2)}`"/>
                  <td>
                    <span v-if="t[notification.status]" class="ba-badge ba-lg badge-status" :style="getBadgeColor(notification.status,true)" v-text="t[notification.status]"></span>
                    <a v-if="invoicesData.fatherIsBuilderall && notification.nfse !== null" :style="getBadgeColor('nfse')" class="label-status cursor-pointer" :href="notification.nfse" target="_blank">NFS-e</a>
                  </td>
                  <td :class="['print-receipt', invoicesData.fatherIsBuilderall && notification.status === 'Completed' && !notification.instant_commission ? '' : 'not-has-items']">
                    <button v-if="invoicesData.fatherIsBuilderall && notification.status === 'Completed' && !notification.instant_commission"
                            @click="print(false, 'ba6-modal-receipt', 'show', notification)"
                            class="ba-btn ba-btn-normal ba-sm ba-rounded"
                    >
                      <builderall-icon code='7535'></builderall-icon>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>

        <nav v-if="!IsEmpty(invoices) && totalPages > 1" class='ba-pagination ba-md ba-flex ba-jc-center'>
          <ul class='ba-list'>
            <li v-if="currentPage > 1" class='ba-nav-item'>
              <a class='ba-back' @click="previousPage">
                <span class='ba-icon'>
                    <builderall-icon code='arrow-left' />
                </span>
              </a>
            </li>
            <li v-for="(a, i) in pagesToShow" :key="i"
                class='ba-nav-item'
            >
              <a :class="['ba-link', currentPage == a ? 'ba-is-active': '']"
                 @click="goToPage(a)"
              >{{ a }}
              </a>
            </li>
            <li v-if="currentPage < totalPages" class='ba-nav-item'>
              <a class='ba-next' @click="nextPage">
                <span class='ba-icon'>
                    <builderall-icon code='arrow-right' />
                </span>
              </a>
            </li>
          </ul>
        </nav>

        <table v-if="IsEmpty(invoices)" class='ba-table ba-md ba-lines'>
          <tbody>
          <tr>
            <td class='ba-no-records-found'>{{ t.no_record_found }}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <!-- NFSE Data Tab -->
      <form v-if="activeTab == 2"
            class="ba-nfse ba-grid ba-gp-1"
            id="formLogin"
            ref="formLogin"
      >
        <div class="ba-left ba-flex ba-f-column">
          <span class="nfse-title">{{ t.contact }}</span>

          <div class='ba-box-input ba-md'>
            <div class='ba-info'>
              <div class='ba-info-left'>
                <label class='ba-label' for='name'>{{ t.name_razao_social }}</label>
              </div>
            </div>
            <input type='text'
                   id='name'
                   v-model="nfseData.razao_social"
                   :class="['ba-input', $v.razao_social_v.$invalid ? 'ba-error' : '']"
                   @input="onChange('razao_social_v', nfseData.razao_social)"
                   placeholder='Enter your name' pattern="[0-9-A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$" />
          </div>
          <div class='ba-box-input ba-md'>
            <div class='ba-info'>
              <div class='ba-info-left'>
                <label class='ba-label' for='name'>CPF/CNPJ (VAT)</label>
              </div>
            </div>
            <input type='text'
                   id='name'
                   v-model="nfseData.cpf_cnpj"
                   @input="onChangeCPFCNPJ('cpf_cnpj_v', nfseData.cpf_cnpj)"
                   :class="['ba-input', $v.cpf_cnpj_v.$invalid || !isValidCPF ? 'ba-error' : '']"
                   placeholder='CPF/CNPJ (VAT)'
                   v-mask="['###.###.###-##', '##.###.###/####-##']" />
          </div>
          <div class='ba-box-input ba-md'>
            <div class='ba-info'>
              <div class='ba-info-left'>
                <label class='ba-label' for='name'>{{ t.contact_email }}</label>
              </div>
            </div>
            <input type='text'
                   id='name'
                   v-model="nfseData.contact_email"
                   @input="onChange('contact_email_v', nfseData.contact_email)"
                   :class="['ba-input', $v.contact_email_v.$invalid ? 'ba-error' : '']"
                   :placeholder='t.contact_email' />
          </div>
          <div class='ba-box-input ba-md'>
            <div class='ba-info'>
              <div class='ba-info-left'>
                <label class='ba-label' for='name'>{{ t.cell_phone }}</label>
              </div>
            </div>
            <input type='text'
                   id='name'
                   v-model="nfseData.celular"
                   @input="onChange('celular_v', nfseData.celular)"
                   :class="['ba-input', $v.celular_v.$invalid ? 'ba-error' : '']"
                   v-mask="['+## (##) #####-####']"
                   :placeholder="t.cell_phone" />
          </div>
          <div class='ba-box-input ba-md'>
            <div class='ba-info'>
              <div class='ba-info-left'>
                <label class='ba-label' for='name'>{{ t.phone }}</label>
              </div>
            </div>
            <input type='text'
                   id='name'
                   v-model="nfseData.telefone"
                   @input="onChange('telefone_v', nfseData.telefone)"
                   :class="['ba-input', $v.telefone_v.$invalid ? 'ba-error' : '']"
                   v-mask="['+## (##) ####-####']"
                   :placeholder="t.phone" />
          </div>
        </div>

        <div class="ba-right ba-flex ba-f-column">
          <span class="nfse-title">{{ t.address }}</span>

          <div class='ba-box-input ba-md'>
            <div class='ba-info'>
              <div class='ba-info-left'>
                <label class='ba-label' for='zipcode'>{{ t.funnel_domain_zip }}</label>
              </div>
            </div>
            <input type='text'
                   id='zipcode'
                   v-model="nfseData.cep"
                   @input="onChange('cep_v', nfseData.cep)"
                   :class="['ba-input', $v.cep_v.$invalid ? 'ba-error' : '']"
                   :placeholder="t.cep_withought_hyphen"
                   pattern="[0-9-A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$"
                   v-mask="['#####-###']" />
          </div>
          <div class="nfse-grid">
            <div class='ba-box-input ba-md'>
              <div class='ba-info'>
                <div class='ba-info-left'>
                  <label class='ba-label' for='name'>{{ t.street_avenue }}</label>
                </div>
              </div>
              <input type='text'
                     id='name'
                     v-model="nfseData.endereco"
                     @input="onChange('endereco_v', nfseData.endereco)"
                     :class="['ba-input', $v.endereco_v.$invalid ? 'ba-error' : '']"
                     :placeholder='t.street_avenue' />
            </div>
            <div class='ba-box-input ba-md'>
              <div class='ba-info'>
                <div class='ba-info-left'>
                  <label class='ba-label' for='name'>{{ t.label_number }}</label>
                </div>
              </div>
              <input type='text'
                     id='name'
                     v-model="nfseData.numero"
                     @input="onChange('enderecoNumero_v', nfseData.numero)"
                     :class="['ba-input', $v.enderecoNumero_v.$invalid ? 'ba-error' : '']"
                     :placeholder='t.label_number' />
            </div>
          </div>
          <div class='ba-box-input ba-md'>
            <div class='ba-info'>
              <div class='ba-info-left'>
                <label class='ba-label' for='name'>{{ t.neighborhood }}</label>
              </div>
            </div>
            <input type='text'
                   id='name'
                   v-model="nfseData.bairro"
                   @input="onChange('bairro_v', nfseData.bairro)"
                   :class="['ba-input', $v.bairro_v.$invalid ? 'ba-error' : '']"
                   :placeholder="t.neighborhood" />
          </div>
          <div class='ba-box-input ba-md'>
            <div class='ba-info'>
              <div class='ba-info-left'>
                <label class='ba-label' for='name'>{{ t.complement }}</label>
              </div>
            </div>
            <input type='text' id='name' v-model="nfseData.complemento" :class="['ba-input']" :placeholder="t.complement" />
          </div>
          <div class="nfse-grid">
            <div class='ba-box-input ba-md'>
              <div class='ba-info'>
                <div class='ba-info-left'>
                  <label class='ba-label' for='name'>{{ t.city }}</label>
                </div>
              </div>
              <input type='text'
                     id='name'
                     v-model="nfseData.cidade"
                     @input="onChange('cidade_v', nfseData.cidade)"
                     :class="['ba-input', $v.cidade_v.$invalid ? 'ba-error' : '']"
                     :placeholder="t.city" />
            </div>
            <div class='ba-box-input ba-md'>
              <div class='ba-info'>
                <div class='ba-info-left'>
                  <label class='ba-label' for='uf'>{{ t.state }}</label>
                </div>
              </div>
              <select class='ba-input ba-select ba-lg' v-model="nfseData.estado" name='uf' id='uf'>
                <option v-for="(l,i) in invoicesData.ufs" :key="i" :value="l" v-text="l"></option>
              </select>
            </div>
          </div>
        </div>
      </form>

      <!-- Billing Tab -->
      <div v-if="activeTab == 3"
           class="ba-flex ba-f-column ba-gp-1"
      >

        <!-- Invoices / Resources -->
        <div class="ba-flex ba-jc-sb ba-gp-06 ba-mg-t-1">
          <div class="invoces-container ba-flex ba-gp-1 ba-f-column">

            <div class='ba-card ba-statistics card-period-not-closed' v-if="period == this.getCurrentPeriod() && !IsEmpty(payments)">
              <div class='ba-top'>
                <span class='ba-icon'>
                    <builderall-icon code='info' />
                </span>
                <span class='ba-title'>{{ t.billing_not_closed_for_period }}</span>
              </div>
            </div>

            <div class='ba-card' v-if="IsEmpty(payments)" style="height: 100%">
              <div class='ba-top'>
                <span class='ba-title' v-text="t.payments"></span>
              </div>
              <span v-text="t.no_information_payments_on_period"></span>
            </div>


            <div v-if="!IsEmpty(payments)"
                 class='ba-card'
                 v-for="(payment, i) in payments"
                 :key="i"
            >
              <div class='ba-top'>
                <span class='ba-title'  style="height: fit-content;">{{ payment.title }}</span>
                <div class='ba-box-items ba-flex ba-gp-1'>
                  <span class='ba-badge ba-green' v-if="payment.status == 'PAID'" v-text="t.paid"></span>
                  <span class='ba-badge ba-red' v-else v-text="t.pending"></span>
                </div>
              </div>
              <div style="width: 100%" class='ba-content ba-flex ba-jc-sb ba-ai-end ba-mg-t-1'>
                <div>
                  <strong>{{t.date_payment}}:</strong> {{payment.date}}
                </div>
                <h4 class="ba-blue">{{`${payment.currency} ${payment.value}`}}</h4>
              </div>
            </div>

          </div>
          <div class='ba-card resources-container'>
            <div class='ba-top'>
              <span class='ba-title'>{{ t.resources }}</span>
            </div>
            <resources-quotas :resources="resources" v-if="!IsEmpty(resources)"/>
            <span v-else v-text="t.no_information_resources_on_period"></span>
          </div>
        </div>
      </div>
    </builderall-loader>

    <ba6-modal modal-id="ba6-modal-receipt">
      <div class='ba-card ba-jc-sb ba-w-100 ba-no-shadow'>
        <div class='ba-top'>
          <span class='ba-title'>{{ t.print_receipt }}</span>
          <div class='ba-box-items ba-flex ba-gp-1'>
            <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="toggleModal('ba6-modal-receipt', 'hide')">
              <builderall-icon code='64f7' />
            </button>
          </div>
        </div>
        <div class="ba-content-main">
          <p class="ba6-change-password-p">{{ t.receipt_info1 }}</p>
          <p class="ba6-change-password-p">{{ t.receipt_info2 }}</p>
        </div>
        <div class="ba-content-footer ba-w-100 ba-grid">

          <div class='ba-box-input ba-md'>
            <div class='ba-info'>
              <div class='ba-info-left'>
                <label class='ba-label' for='name'>{{ t.ush_url_name }}</label>
              </div>
            </div>
            <input type='text' id='name' :class="['ba-input', e.has('name') ? 'ba-error' : '']" v-model="userData.nome"
                   placeholder='Enter your name' pattern="[0-9-A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$"
            />
            <span v-if="e.has('name')" v-text="e.first('name')" class='ba-validation-text' />
          </div>
          <div class='ba-box-input ba-md'>
            <div class='ba-info'>
              <div class='ba-info-left'>
                <label class='ba-label' for='endereco'>{{ t.label_endereco }}</label>
              </div>
            </div>
            <input type='text' id='endereco' :class="['ba-input', e.has('address') ? 'ba-error' : '']" v-model="userData.endereco"
                   placeholder='Enter your name' pattern="[0-9-A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$"
            />
            <span v-if="e.has('address')" v-text="e.first('address')" class='ba-validation-text' />
          </div>

          <div class='ba-box-input ba-md'>
            <div class='ba-info'>
              <div class='ba-info-left'>
                <label class='ba-label' for='city'>{{ t.label_city_state }}</label>
              </div>
            </div>
            <input type='text' id='city' :class="['ba-input', e.has('city') ? 'ba-error' : '']" v-model="userData.cidade"
                   placeholder='Enter your name' pattern="[0-9-A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$"
            />
            <span v-if="e.has('city')" v-text="e.first('city')" class='ba-validation-text' />
          </div>

          <!-- VAT Number -->
          <div class='ba-box-input ba-md'>
            <div class='ba-info'>
              <div class='ba-info-left'>
                <label class='ba-label' for='vat'>{{ t.cpf_vat_number }}</label>
              </div>
            </div>
            <input type='text' id='vat' :class="['ba-input']" v-model="userData.vat_number"
                   placeholder='Enter your name' pattern="[0-9-A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$"
            />
          </div>

          <!-- Optional Data -->
          <div class='ba-box-input ba-md' v-if="!IsEmpty(userData.vat_number)">
            <div class='ba-info'>
              <div class='ba-info-left'>
                <label class='ba-label' for='company'>{{ t.label_vat_company_name }}</label>
              </div>
            </div>
            <input type='text' id='company' :class="['ba-input']" v-model="company_name"
                   placeholder='Enter your name' pattern="[0-9-A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$"
            />
          </div>
          <div class='ba-box-input ba-md' v-if="!IsEmpty(userData.vat_number)">
            <div class='ba-info'>
              <div class='ba-info-left'>
                <label class='ba-label' for='address'>{{ t.label_vat_company_address }}</label>
              </div>
            </div>
            <input type='text' id='address' :class="['ba-input']" v-model="company_address"
                   placeholder='Enter your name' pattern="[0-9-A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$"
            />
          </div>
        </div>
        <span class='ba-btn ba-md ba-blue ba-f-12'
              @click="saveAndPrintReceipt()"
        >
              {{ t.mc_admin_send_button }}
            </span>
      </div>
    </ba6-modal>

    <ba6-modal modal-id="ba6-modal-cancel">
      <div class="ba-card ba-jc-sb ba-w-100 ba-no-shadow">
        <div class='ba-top'>
          <span class='ba-title'>{{ t.button_cancelar }}</span>
          <div class='ba-box-items ba-flex ba-gp-1'>
            <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="toggleModal('ba6-modal-cancel', 'hide')">
              <builderall-icon code='64f7' />
            </button>
          </div>
        </div>
        <div class="ba-content-main">
          <p v-if="!isSupported(currentInvoice.method)" class="ba6-change-password-p" v-html="cancelUnavailable"/>
          <p v-else-if="!currentInvoice.recorrente_ativo" class="ba6-change-password-p">{{ t.label_pagamento_recorrente_cancelado }}</p>
          <p v-else class="ba6-change-password-p" v-html="cancelConfirmation"/>
        </div>
        <div class='ba-box-input ba-w-100'>
          <input type='text' id='confirmCancel' :class="['ba-input']" v-model="confirmCancel"
                 :placeholder='t.are_you_shure'
          />
        </div>
        <span :disabled="disabledButtonCancel"
              class='ba-btn ba-md ba-blue ba-f-12'
              @click="disabledButtonCancel ? '' : cancel(invoicesData.cancelRoute)"
        >
              {{ t.cancel_recurrency }}
        </span>
      </div>
    </ba6-modal>

    <ba6-modal modal-id="ba6-modal-payment">
      <div class="ba-card ba-jc-sb ba-w-100 ba-no-shadow payment-modal">
        <div class='ba-top'>
          <span class='ba-title'>{{ t.payment_method }}</span>
          <div class='ba-box-items ba-flex ba-gp-1'>
            <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="toggleModal('ba6-modal-payment', 'hide')">
              <builderall-icon code='64f7' />
            </button>
          </div>
        </div>
        <div class="ba-content-main">
          <span class="bullet">{{ t.payment_method_description_1 }}</span>
          <span class="bullet" v-html="t.payment_method_description_2"></span>
          <span class="bullet">{{ t.payment_method_description_3 }} <b><i>{{ t.make_payment_by_changing_the_method }}</i></b>.</span>
        </div>
        <div class="ba-content-main ba-w-100 ba-flex ba-f-column ba-gp-1">
          <div class='ba-box-input'>
            <div class='ba-info'>
              <div class='ba-info-left'>
                <label class='ba-label' for='input_id'>{{ t.payer_email }}</label>
              </div>
            </div>
            <input type='text' disabled class='ba-input ba-disabled' :value="this.payerEmail" />
          </div>

          <div class='ba-box-input'>
            <div class='ba-info'>
              <div class='ba-info-left'>
                <label class='ba-label' for='input_id'>{{ t.card_number }}</label>
              </div>
            </div>
            <input type='text' class='ba-input ba-disabled' disabled :value="this.cardNumber" />
          </div>

          <div class='ba-box-input'>
            <div class='ba-info'>
              <div class='ba-info-left'>
                <label class='ba-label' for='input_id'>{{ t.card_brand }}</label>
              </div>
            </div>
            <input type='text' class='ba-input ba-disabled' disabled :value="this.cardBrand" />
          </div>

          <a class="ba-btn ba-lg ba-blue ba-f-12" :href="changePaymentMethodUrl" target="_blank">{{ t.make_payment_by_changing_the_method }}</a>
        </div>
      </div>
    </ba6-modal>

    <pause-modal
      :view="view.pause_account"
      :current-invoice="currentInvoice"
      :invoices-data="invoicesData"
    />
  </div>
</template>

<script>
import validateCPFCNPJ from "../../../../helpers/cpf-cnpj-validator";
import Errors from "../../../../../../global/js/errors";
import qs from "qs";
const { required, minLength, numeric, email } = require('vuelidate/lib/validators')

export default {
  name: "ba6-invoices",
  props: ['view', 'invoicesData'],
  data() {
    return {
      nfseData: null,
      userData: null,
      invoices: null,
      loading: true,
      loading_invoices: false,
      loading_receipt: false,
      firstTime: true,
      t: null,
      typeStatus: [
        {'status':'default',           'background': '#C4C4C4','color':'#4D5D71'},//gray
        {'status':'warning',           'background': '#F0E5FF','color':'#4D5D71'},//purple
        {'status':'canceled',          'background': '#FCEDE9','color':'#4D5D71'},//red
        {'status':'pending',           'background': '#FDF6E9','color':'#4D5D71'},//yellow
        {'status':'recorrente',        'background': '#EAF7EE','color':'#4D5D71'},//light-green
        {'status':'extraConnection',   'background': '#FDF6E9','color':'#4D5D71'},//orange
        {'status':'nfse',              'background': '#FDF6E9','color':'#4D5D71'},//orange
        {'status':'extraStorage',      'background': '#FDF6E9','color':'#4D5D71'},//orange
        {'status':'domain',            'background': '#E6EFFA','color':'#4D5D71'},//pink
        {'status':'instantCommissions','background': '#EAF7EE','color':'#4D5D71'},//green
        {'status':'refunded',          'background': '#FDF6E9','color':'#4D5D71'},//light-orange
        {'status':'signup',            'background': '#E6EFFA','color':'#4D5D71'},//light-blue
      ],
      currentInvoice: '',
      activeTab: 1,
      setToggleModal: true,
      e: new Errors([]),
      notification: null,
      printReceiptType: 'notification',
      currency_invoice: null,
      company_name: '',
      company_address: '',
      confirmCancel: '',

      payments: [],
      periods: ['0000-00'],
      period: null,
      resources: [],

      itensPerPage: 50,
      currentPage: 1,
      disabledButtonCancel: true,
      paymentType: '',
      cardBrand: '',
      cardNumber: '',
      payerEmail: '',
      changePaymentMethodUrl: this.view.handler_routes.route_checkout_plans,
      isValidCPF: false,
      statusToShowShow: ['subscr_cancel', 'Completed'],

      // Lazy Validations
      razao_social_v: null,
      cpf_cnpj_v: null,
      contact_email_v: null,
      celular_v: null,
      telefone_v: null,
      cep_v: null,
      endereco_v: null,
      enderecoNumero_v: null,
      bairro_v: null,
      cidade_v: null,

      nfseData: {
        razao_social: '',
        cpf_cnpj: '',
        contact_email: '',
        celular: '',
        telefone: '',
        cep: '',
        endereco: '',
        enderecoNumero: '',
        bairro: '',
        cidade: '',
      }
    }
  },
  validations: {
    razao_social_v: {
      required,
      minLength: minLength(1),
    },
    cpf_cnpj_v: {
      required,
    },
    contact_email_v: {
      email
    },
    celular_v: {
      numeric,
      minLength: minLength(13)
    },
    telefone_v: {
      numeric,
      minLength: minLength(12)
    },
    cep_v: {
      required
    },
    endereco_v: {
      required
    },
    enderecoNumero_v: {
      required
    },
    bairro_v: {
      required
    },
    cidade_v: {
      required
    }
  },
  created() {
    this.getInvoices()
  },
  mounted() {
    this.t = this.view.translation
    this.nfseData = this.invoicesData.nfse_data
    this.userData = this.view.invoices_data.user_data

    this.setPlaceholders();
    this.period = this.getStartingPeriod();

    this.assignFormValues();
  },
  methods: {
    onChangeCPFCNPJ(key, value) {
      this[key] = value
      this.$v[key].$touch();
    },
    onChange(key, value) {
      var newVal = value.replace(/[-+() ]/g, '');

      this[key] = newVal
      this.$v[key].$touch();
    },
    openPauseModal(invoice) {
      this.currentInvoice = invoice
      $('#modal-delete-account').toggle('show');
    },
    getInvoices() {
      let vm = this
      this.loading = true
      this.loading_invoices = true

      axios
        .get('/us/office/get-invoices')
        .then((response) => {
          vm.invoices = response.data.data
        })
        .catch((error) => {
          alertMsg('error', error.message)
        })
        .finally(() => {
          vm.loading_invoices = false
          vm.changeLoadingStatus(false)
        })
    },
    paymentMethod (payment) {
      this.paymentType = payment.payment_method;
      this.cardNumber  = payment.last_four_digit;
      this.cardBrand   = payment.brand;
      this.payerEmail  = payment.payer_email;

      if (payment.change_payment_method_url) {
        this.changePaymentMethodUrl = payment.change_payment_method_url;
      }

      this.toggleModal('ba6-modal-payment', 'show')
    },
    getBadgeColor(status,oncollapse){
      let item = '';
      let nameToFind = '';
      if(oncollapse)
      {
        switch (status) {
          case 'Completed':
            // instantCommissions because he has light green
            nameToFind = 'instantCommissions';
            break;
          case 'Pending':
            // canceled because he has yellow
            nameToFind = 'pending';
            break;
          case 'Falha':
          case 'Failed':
          case 'subscr_failed':
          case 'Cancel':
          case 'Cancelado':
          case 'subscr_cancel':
            // pending because he has red
            nameToFind = 'canceled';
            break;
          case 'Refunded':
            nameToFind = 'refunded';
            break;
          case 'Aguardando Reembolso':
            //extraConnection because he has orange
            nameToFind = 'extraConnection';
            break;
          case 'Aberta':
            //recorrente because he has green
            nameToFind = 'instantCommissions';
            break;
          case 'subscr_signup':
          case 'signup':
          case 'Available':
            //recorrente because he has light blue
            nameToFind = 'signup';
            break;
          default:
            //default with gray color
            nameToFind = 'default';
            break;
        }
      }
      let searchBy = !oncollapse ? status : nameToFind;
      item = this.typeStatus.find(s => s.status == searchBy);
      return 'background-color:'+item['background']+';color:'+item['color'];
    },
    toggleInvoice(index) {
      this.invoices[index].open_accordion = !this.invoices[index].open_accordion
    },
    showPaynow(invoice) {
      if(!invoice.fee && !invoice.recorrente && invoice.titulo != 'Payment of domain' && !invoice.hiden_plan && !invoice.instant_commission && !invoice.plano) {
        return ['stripe', 'paypal', 'authorize', 'pagseguro'].includes(invoice.method);
      }
    },
    invoiceUrl(path, invoice) {
      return `${path}/${invoice.id}`
    },
    isSupported(tipo) {
      return ['stripe', 'paypal', 'authorize', 'builderall_gateway'].includes(tipo);
    },
    toggleModal(data, action){
      $(`#${data}`).toggle(action);
    },
    print(isBilling, data, action, notification) {
      if (!isEmpty(notification)) {
        this.notification = notification
        this.currency_invoice = notification.currency;
      } else {
        this.printNotifications = this.payments.map ((payment) => payment.notification_id);
        this.printReceiptPeriod = this.period;
      }

      this.toggleModal(data, action)
    },
    validadeUserData() {
      if (!this.userData.nome) {
        this.e.add('name', 'erro nome')
      }
      if (!this.userData.endereco) {
        this.e.add('address', 'erro endereço')
      }
      if (!this.userData.cidade) {
        this.e.add('city', 'erro cidade')
      }
      return this.e.any();
    },
    changeLoadingStatus(status) {
      if (!this.loading_invoices && !this.loading_receipt)
      {
        this.loading = status;
      }
    },
    async cancel(url) {
      this.loading = true;

      await this.toggleModal('ba6-modal-cancel', 'hide')

      axios.post(`${url}/${this.currentInvoice.id}`, {}).then(() => {
        this.currentInvoice.recorrente_ativo = false;
        alertMsg('success', this.t.label_pagamento_recorrente_cancelado);
      }).catch(({response}) => {
        alertMsg('error', response.data.message);
      })
        .finally(() => {
          this.changeLoadingStatus(false);
        })
    },
    async saveAndPrintReceipt() {
      await this.validadeUserData();
      if (this.e.any()) {
        return;
      }

      await this.toggleModal('ba6-modal-receipt', 'hide')
      await this.saveUserReceiptData()

      const receiptRoute = this.printReceiptType == 'notification'
        ? `/${this.invoicesData.lang}/office/invoices/print-receipt/${this.notification.id}`
        : `/us/office/billing/${this.printReceiptPeriod}/print-receipt`

      window.open(receiptRoute);
    },
    async saveUserReceiptData() {
      this.loading = true;

      let notifications = this.printReceiptType == 'notification' ? [this.notification.id] : this.printNotifications

      for (let i = 0; i < notifications.length; i++) {
        const notification = notifications[i];
        let data = {
          'company_name': this.company_name,
          'company_address': this.company_address,
          'notification_id': notifications,
          'user': {'nome': this.userData.nome, 'endereco': this.userData.endereco, 'cidade': this.userData.cidade, 'vat_number': this.userData.vat_number}
        };
        await axios.post(`${this.view.handler_routes.rota_office_invoices_save_user}`, qs.stringify(data))
          .then(({data}) => {
            if (this.printReceiptType == 'notification') {
              alertMsg('success', data.message);
            }
          }).catch(({response}) => {
            alertMsg('error', response.data.message);
          });
      }

      this.changeLoadingStatus(false);
    },
    validateCPFCNPJ (value) {
      return validateCPFCNPJ(value);
    },
    IsEmpty(val) {
      return isEmpty(val)
    },
    log(data) {
      console.log(data)
      return 'hello'
    },

    // Billing
    refresh () {
      this.loading = true;

      axios.get(`/${window.__env.locale}/office/billing?period=${this.period}`)
        .then((r) => {
          this.periods   = r.data.data.periods;
          this.payments  = r.data.data.payments;
          this.resources = r.data.data.resources;
        })
        .catch((err) => { console.error(err)})
        .finally(() => this.changeLoadingStatus(false));
    },
    getCurrentPeriod () {
      var currentDate = new Date();
      return `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}`;
    },
    getStartingPeriod (){
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('period') || this.getCurrentPeriod()
    },
    setPlaceholders () {
      this.periods   = ['0000-00'];
      this.resources = [{
        "title": "Domains",
        "slug": "domain",
        "type": "SIMPLE",
        "left": null,
        "right": "0 of 0",
        "current": 0,
        "limit": 0
      },
        {
          "title": "Hard drive Space",
          "slug": "storafe",
          "type": "DOUBLE",
          "left": "0 GB",
          "right": "0 GB",
          "current": 0,
          "limit": 0
        },
        {
          "title": "Subscribers",
          "slug": "mailingboss-subscribers",
          "type": "DOUBLE",
          "left": "0 of 0",
          "right": "0%",
          "current": 0,
          "limit": 0
        }
      ];
      this.payments  = [
        {
          "title": "Payment",
          "currency": "USD",
          "value": "0.00",
          "date": "0000-00-00",
          "status": "PAID"
        },
        {
          "title": "Payment",
          "currency": "USD",
          "value": "0.00",
          "date": "0000-00-00",
          "status": "PAID"
        },
        {
          "title": "Payment",
          "currency": "USD",
          "value": "0.00",
          "date": "0000-00-00",
          "status": "PAID"
        }];
    },
    appendPeriodToUrl () {
      const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?period=' + this.period;
      window.history.pushState({ path: newurl }, '', newurl);
    },
    paginarDados(data, start, finish) {
      return !this.IsEmpty(data) ? data.slice(start, finish) : data;
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    goToPage(page) {
      if (page !== '...') {
        this.currentPage = page;
      }
    },
    async submitNfseData() {
      this.loading = true;
      await axios.post(`${this.view.handler_routes.rota_office_invoices_save_user}`, qs.stringify(this.nfseData))
        .then(response => {
          alertMsg('success', response.data.message);
        })
        .catch(e => {
          alertMsg('error', e.data.message);
        })
        .finally(f => {
          this.changeLoadingStatus(false);
          // window.location.reload();
        });
    },
    getDomainName(note) {
      let domainTitle

      note.items.forEach(x => {
        /\s/.test(x.title) ? '' : domainTitle = x.title
      })

      return domainTitle
    },
    getAddressInfoByZipcode(zipcode) {

      if (this.firstTime) {
        this.firstTime = false;
        return;
      }

      this.loading = true
      this.loading_receipt = true

      axios
        .get(`/${this.invoicesData.lang}/office/viacep/${zipcode}`)
        .then((response)=> {
          let data = response.data.data;
          if(response.data.success) {
            if (data) {
              this.nfseData.estado      = data.uf ? data.uf.toUpperCase() : '';
              this.nfseData.codigo_ibge = data.ibge ? data.ibge : '';
              this.nfseData.bairro      = data.bairro ? data.bairro : this.nfseData.bairro;
              this.nfseData.endereco    = data.logradouro ? data.logradouro : this.nfseData.endereco;
              this.nfseData.cidade      = data.localidade ? data.localidade : '';
              this.nfseData.complemento = data.complemento ? data.complemento : this.nfseData.complemento;
            }
          }
        })
        .catch((error)=>{
          console.log(error);
        })
        .finally(() => {

          this.loading_receipt = false;
          this.changeLoadingStatus(false);
        });
    },
    assignFormValues() {
      this.razao_social_v = this.nfseData.razao_social;
      this.cpf_cnpj_v = this.nfseData.cpf_cnpj;
      this.contact_email_v = this.nfseData.contact_email;
      this.celular_v = this.nfseData.celular;
      this.telefone_v = this.nfseData.telefone;
      this.cep_v = this.nfseData.cep;
      this.endereco_v = this.nfseData.endereco;
      this.enderecoNumero_v = this.nfseData.numero;
      this.bairro_v = this.nfseData.bairro;
      this.cidade_v = this.nfseData.cidade;
    },
  },
  computed: {
    cancelUnavailable() {
      return this.t.cancel_unavailable_text.split('{gateway}').join(this.currentInvoice.method);
    },
    'nfseData.cep': {
      handler(newValue) {
        newValue = newValue.replace("-", "");
        if (newValue.length >= 8 ) {
          this.getAddressInfoByZipcode (newValue);
        }
      }
    },
    'nfseData.cpf_cnpj': {
      handler(newValue) {
        newValue = newValue.replace(".", "").replace("-", "");
        if (newValue.length >= 11 ) {
          this.isValidCPF = this.validateCPFCNPJ(newValue);
        }
      }
    },
    cancelConfirmation() {
      return this.t.cancel_confirmation.split('{word}').join(this.t.button_cancelar.toLowerCase());
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.itensPerPage;
      const finish = start + this.itensPerPage;
      return this.paginarDados(this.invoices, start, finish);
    },
    pagesToShow() {
      const pages = [];
      const totalPages = this.totalPages;

      if (totalPages <= 6) {
        for (let i = 1; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        const initPages = [1, 2, 3];
        const finalPages = [totalPages - 2, totalPages - 1, totalPages];

        pages.push(...initPages, '...', ...finalPages);
      }

      return pages;
    },
    totalPages() {
      return Math.ceil(this.invoices.length / this.itensPerPage);
    }
  },
  watch: {

    'nfseData.cep': {
      handler(newValue) {
        newValue = newValue.replace("-", "");

        if (newValue.length >= 8 ) {
          this.getAddressInfoByZipcode (newValue);
        }
      }
    },
    'nfseData.cpf_cnpj': {
      handler(newValue) {
        newValue = newValue.replace(".", "").replace("-", "");

        if (newValue.length >= 11 ) {
          this.isValidCPF = this.validateCPFCNPJ(newValue);
        }
      }
    },

    userData: {
      handler(newVal, oldVal) {
        if (newVal.nome.length > 0) {
          this.e.remove('name')
        } else {
          this.e.add('name', 'erro nome')
        }

        if (newVal.endereco.length > 0) {
          this.e.remove('address')
        } else {
          this.e.add('address', 'erro endereço')
        }

        if (newVal.cidade.length > 0) {
          this.e.remove('city')
        } else {
          this.e.add('city', 'erro cidade')
        }
      },
      deep: true
    },
    period () {
      this.refresh();
      this.appendPeriodToUrl();
    },
    confirmCancel(newVal) {
      this.disabledButtonCancel = newVal.toLowerCase() !== this.t.button_cancelar.toLowerCase()
    }
  }
}
</script>


<style scoped lang="scss">
.ba-top {
  grid-template-columns: 1fr auto;
  display: grid;
  gap: 16px;
  width: 100%;
  .ba-title {
    height: 28px;
    border-bottom: 1px solid #b4c4d7;
    color: #4D5D71;
    display: flex;
  }
}
.ba-invoices {
  .invoice {
    width: 100%;
    height: auto;
    border-radius: 16px;
    border: 1px solid rgba(213, 222, 233, 0.50);
    transition: .8s;
    &.collapsed {
      overflow: hidden;
      transition: max-height .8s;
      height: auto;
      max-height: 77px;
    }
    .header-accordion {
      padding: 20px;
      &.oppened {
        border-radius: 16px 16px 0 0;
        border-bottom: 1px solid rgba(213, 222, 233, 0.80);
        background: #F7F8FC;
      }
      .left {
        gap: 8px;
        .ba-f-16 {
          font-size: 16px;
        }
      }
      .right {
        gap: 8px;
        .badge-status {
          font-family: Montserrat;
          font-size: 12px;
          font-weight: 700;
        }
      }
    }
    .body-accordion {
      padding: 20px;

      .first-informations {
        display: inline-flex;
        align-items: baseline;
        gap: 8px;
        .payment-method {
          padding: 6px 8px;
          border-radius: 6px;
          border: 1px solid #4D5D71;
          color: #4D5D71;

          font-family: Montserrat;
          font-size: 12px;
          font-weight: 500;
          letter-spacing: 0.66px;
        }
      }
      .informations {
        .informations-data, .informations-price {
          font-family: Montserrat;
        }
        .informations-data {
          color: #4D5D71;
          font-size: 13px;
          font-weight: 700;
          letter-spacing: 1.43px;
        }
        .informations-price {
          font-size: 12px;
          color: #8D9EB5;
          font-weight: 500;
          letter-spacing: 0.6px;
        }
      }
    }
  }
}

.ba-nfse {
  grid-template-columns: 1fr 1fr;
  .ba-left, .ba-right {
    gap: 16px;
    width: 100%;
    .nfse-title {
      color: #4D5D71;
      font-family: Montserrat;
      font-size: 12px;
      font-weight: 700;
      letter-spacing: 0.66px;
    }
    .ba-label {
      color: #111827;
      font-family: Montserrat;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%;
    }
    .nfse-grid {
      display: grid;
      grid-template-columns: 1fr 140px;
      gap: 16px;
    }
  }
}
.ba-content-footer {
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.rotate-180{
  transform: rotate(-180deg);
}
.icon-transition {
  transition: transform .3s ease-in-out;
}
.ba-f-12 {
  font-size: 12px;
  text-transform: capitalize;
}
.text-capitalize {
  text-transform: capitalize !important;
}

.invoces-container {
  width: 65%;
  padding-bottom: 200px;
}

.resources-container {
  width: 35%;
  height: fit-content;
}

h4 {
  font-size: 18px;
}

.card-period-not-closed {
  font-size: 15px;
  min-height: unset;

  .ba-top {
    .ba-title {
      font-size: 15px;
    }
    .ba-icon {
      width: 35px;
      height: 35px;

      builderall-icon {
        --builderall-icon-size: 25px;
      }
    }
  }
}
.payment-modal {
  .bullet {
    display: block;
    margin-bottom: 5px;
  }
  .bullet:before {
    content: "\2022";
    font-size: 1.5em;
    margin-right: 5px;
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/office-v6/account-settings/routes/Invoices.vue